import WealthRM from "../components/WealthRM";
import NavBarHome from "../components/NavBarHome";

const Careers = () => {
  return (
    <div className="w-full relative bg-white font-istok-web">
      <NavBarHome
        navBarHomeWidth="1690px"
        navBarHomePosition="absolute"
        navBarHomeTop="50px"
        navBarHomeLeft="113px"
        navBarHomeAlignSelf="unset"
      />

      <div className="flex flex-col items-start justify-start gap-11 text-21xl text-darkslateblue px-12 mt-8">
        <div className="flex flex-row items-center justify-start text-11xl gap-3 text-deepskyblue-200">
          <img
            className="relative w-[60.5px] object-cover"
            alt=""
            src="/job-1@2x.png"
          />
          <b className="w-[328px] relative leading-[100%] uppercase inline-block h-[33px] shrink-0">
            Open job positions
          </b>
        </div>

        <WealthRM
          Job_Opening="WEALTH RELATIONSHIP MANAGER"
          Location={`Mumbai & pune`}
        />
        <WealthRM Job_Opening="COMMODITY ADVISOR" Location="Mumbai" />
        <WealthRM Job_Opening="MID CORPORATE - BRM" Location="Mumbai" />
        <WealthRM
          Job_Opening=" PCG Advisory"
          Location="Hyderabad, Chennai, Bangalore, Kolkata, Pune, Delhi"
        />
        <WealthRM
          Job_Opening="KYC & AML EXECUTIVE"
          Location="Goregaon, Mumbai"
        />
        <WealthRM Job_Opening="Telephone Operator" Location="Juhu,Mumbai" />
      </div>

      <div className="px-12 mt-12">
        <div className="flex flex-col items-center justify-start p-12 text-white box-border gap-10 bg-[url('/public/join-our-team@3x.png')] bg-cover bg-no-repeat bg-[top]">
          <b className="relative leading-[100%] text-21xl uppercase inline-block [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0.25)]">
            Join Our Team
          </b>
          <div className="relative text-13xl leading-[130%] capitalize text-center inline-block [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)]">
            At StaffSurge Consultancy, we're always looking for passionate,
            talented individuals to join our growing team.If you have a knack
            for connecting talent with opportunity and a desire to help
            businesses thrive, we want to hear from you
          </div>
        </div>
      </div>
    </div>
  );
};

export default Careers;
